angular.module('app').service('Microservice', [
    '$http',
    function($http) {
        var api = {};

        api.interceptor = function(microservice, method, action, payload) {
            var p1 = payload;

            if (['get', 'head', 'jsonp', 'delete'].indexOf(method) !== -1) {
                p1 = {};
            }

            return $http[method]('/api/microservice/' + microservice + action, p1).then(function(response) {
                return response.data;
            });
        };

        return api;
    },
]);
